import { Col, Row } from 'antd';
import styled from 'styled-components';
import IcStaffs from '../icons/IcStaffs';
import IcManager from '../icons/IcManager';
import IcSale from '../icons/IcSale';
import IcMarketing from '../icons/IcMarketing';
import useGetEmployeeSummary from '../services/hooks/useGetEmployeeSummary';
import { useMemo } from 'react';

const EmployeeSummary = () => {
  const { data } = useGetEmployeeSummary();
  const summaryItems = useMemo(
    () => [
      { id: 'staffs', label: 'total employees', value: data?.totalEmployee, icon: <IcStaffs /> },
      { id: 'manager', label: 'managers', value: data?.totalManager, icon: <IcManager /> },
      { id: 'sale', label: 'sales', value: data?.totalSale, icon: <IcSale /> },
      { id: 'marketing', label: 'marketings', value: data?.totalMarketing, icon: <IcMarketing /> },
    ],
    [data]
  );

  return (
    <div>
      <Row gutter={16}>
        {summaryItems?.map((item) => (
          <Col span={6} key={item.id}>
            <SummaryItemBoxStyled>
              <div className='info-box'>
                <div className='text label-text'>{item.label}</div>
                <div className='text value-text'>{item.value || 0}</div>
              </div>
              <div>{item.icon}</div>
            </SummaryItemBoxStyled>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default EmployeeSummary;

const SummaryItemBoxStyled = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  .info-box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .text {
    color: #1d2129;
    font-family: Poppins;
    font-style: normal;
    line-height: normal;
    text-transform: uppercase;
  }
  .label-text {
    color: #505050;
    font-size: 16px;
    font-weight: 600;
  }
  .value-text {
    font-size: 32px;
    font-weight: 500;
  }

  &:hover {
    transform: scale(1.01);
    transition: transform 0.3s ease-in-out;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }
`;
